/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

$(document).ready(function(){

  if($('.advance_option_product').hasClass('hide_price')){
  
  }else{
  
var product_id = $('.customOptions').attr('data-product-id');
  if(product_id != ''){
    $.ajax({
        type: "POST",
        url: "https://dev.shopifyexperthelp.com/app/AMLWeddingBands/Product_page.php",
        data:{'product_id': product_id},
        async: false,
        success: function(dataitem) {
          var dataitem = $.parseJSON(dataitem);
          var status = dataitem.status;
          var jsonData = dataitem.jsonData;
          //console.log(dataitem);
          if(status == '1'){
            localStorage.removeItem("product_json");
            localStorage.setItem('product_json', JSON.stringify(jsonData));
          }
          
            
        }
    });
      console.log("amt#######");
      var totle_price = '';
      var get_json = localStorage.getItem('product_json');
      if(get_json != ''){
        
        var data_pro = $.parseJSON(get_json);
        console.log(data_pro);

        //9ct function js
        function ct9ITG() {
          var number_of_diamonds = $('.optionNumberDiamonds input').val();
          if(number_of_diamonds != ''){
            var number_of_diamonds = parseFloat(number_of_diamonds);
          }else{
            var number_of_diamonds = 0;
          }
          
          var weight_per_diamonds_input = $('.optionIndividualDiamondWeight input').val();
          if(weight_per_diamonds_input != ''){
            var weight_per_diamonds = parseFloat(weight_per_diamonds_input);
          }else{
            var weight_per_diamonds = 0.00;
          }
    
          var width_select = $(".optionWidth input[type='radio']:checked").val();
          //alert(width_select);
          //size_column
          var size_options = $(".optionSizes input[type='radio']:checked").val();
          var size_options = 'size_column_'+size_options;
          if(size_options in data_pro){
              var size_option = data_pro[size_options];
          }

          //labour all size
          var labour_size_option = $(".optionCarat input[type='radio']:checked").val();
          var labour_size_option = 'labour_'+labour_size_option;
          if(labour_size_option in data_pro){
            var optionCarat = data_pro[labour_size_option];
          }

          //formula start
          var markupnormal = parseFloat(data_pro.mark_up_normal);
          var exchangerate = parseFloat(data_pro.exchange_rate);
          var labour9ct = parseFloat(optionCarat);
          var diamondPercarate = parseFloat(data_pro.diamonds_per_carat);
          var settingCharge = parseFloat(data_pro.setting_charge);
          var numberOfStones = number_of_diamonds;
          var boxAndPouchCost = parseFloat(data_pro.box_pouch_cost);
          var widthrequired = parseFloat(width_select);
          var widthrNeverChange = parseFloat(data_pro.width_never_change);
          
          var nineCto28 = parseFloat(data_pro.nine_ct_to_i28);
          var columnAfterSizeColumn = parseFloat(size_option);
          var hallmarkPerGramCostCost2 = parseFloat(data_pro.hallmark_per_gram_cost);
          var gold$B = parseFloat(data_pro.gold_b);
  
          var totaldiamondweight = parseFloat(number_of_diamonds) * parseFloat(weight_per_diamonds);
          var diamondCostE = ( numberOfStones * settingCharge ) + ( totaldiamondweight * diamondPercarate );
console.log("diamondCostE",diamondCostE);
          var widthPerMM = ( nineCto28 / widthrNeverChange * widthrequired ) / 17.2;
          console.log("widthPerMM", widthPerMM);
          var hallmarkPerGramCostCost = ( hallmarkPerGramCostCost2 * exchangerate );
          var gold$Cost = ( gold$B + 50 ) * 1.06 / 31.1 * 0.375;
          var hay = ( labour9ct / exchangerate ) * markupnormal + hallmarkPerGramCostCost2;
 console.log("hay",hay);
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * markupnormal + boxAndPouchCost;
          console.log("diamondSellEWithBox",diamondSellEWithBox);
          var columnBeforeTotalPriceColumn = ( columnAfterSizeColumn * widthPerMM );
             console.log("columnBeforeTotalPriceColumn",columnBeforeTotalPriceColumn);
       
          var SellPerGram = (gold$Cost) / exchangerate * markupnormal;
            console.log("SellPerGram",SellPerGram);
       
          var totalPrice = ( SellPerGram * columnBeforeTotalPriceColumn ) + diamondSellEWithBox + hay;
            console.log("totalPrice",totalPrice);
        
          var baseprice = parseFloat($('.customOptions').attr('data-baseprice'));
          if(!isNaN(baseprice)) {
            var baseprice = baseprice;
          }else{
            var baseprice = 0;
          }
          var totalPrice = totalPrice + baseprice;
                   
           $('#product_price').text('£'+totalPrice.toFixed(2));
           totle_price = '£'+totalPrice.toFixed(2);

        }

        //14ct, 18ct, 22ct function js
        function Ct14ITG(getvalue) {
          var number_of_diamonds = $('.optionNumberDiamonds input').val();
          if(number_of_diamonds != ''){
            var number_of_diamonds = parseFloat(number_of_diamonds);
          }else{
            var number_of_diamonds = 1;
          }
          
          var weight_per_diamonds_input = $('.optionIndividualDiamondWeight input').val();
          if(weight_per_diamonds_input != ''){
            var weight_per_diamonds = parseFloat(weight_per_diamonds_input);
          }else{
            var weight_per_diamonds = 1;
          }
    
          var width_select = $(".optionWidth input[type='radio']:checked").val();
          //alert(width_select);
          //size_column
          var size_options = $(".optionSizes input[type='radio']:checked").val();
          var size_options = 'size_column_'+size_options;
          if(size_options in data_pro){
              var size_option = data_pro[size_options];
          }

          //labour all size
          var labour_size_option = $(".optionCarat input[type='radio']:checked").val();
          var labour_size_option = 'labour_'+labour_size_option;
          if(labour_size_option in data_pro){
            var optionCarat = data_pro[labour_size_option];
          }

          //formula start
          var markupnormal = parseFloat(data_pro.mark_up_normal);
          var exchangerate = parseFloat(data_pro.exchange_rate);
          var labour9ct = parseFloat(optionCarat);
          var diamondPercarate = parseFloat(data_pro.diamonds_per_carat);
          var settingCharge = parseFloat(data_pro.setting_charge);
          var numberOfStones = number_of_diamonds;
          var boxAndPouchCost = parseFloat(data_pro.box_pouch_cost);
          var widthrequired = parseFloat(width_select);
          var widthrNeverChange = parseFloat(data_pro.width_never_change);
          if(getvalue == 'ct14'){
            var ct9_14ct = parseFloat(data_pro.ct9_to_14ct_B);
          }else if(getvalue == 'ct18') {
            var ct9_14ct = parseFloat(data_pro.ct9_to_18ct_B);
          }else if(getvalue == 'ct22') {
            var ct9_14ct = parseFloat(data_pro.ct9_to_22ct_B);
          }
          
          var nineCto28 = parseFloat(data_pro.nine_ct_to_i28);
          var columnAfterSizeColumn = parseFloat(size_option);
          var hallmarkPerGramCostCost2 = parseFloat(data_pro.hallmark_per_gram_cost);
          var gold$B = parseFloat(data_pro.gold_b);
  
          var totaldiamondweight = parseFloat(number_of_diamonds) * parseFloat(weight_per_diamonds);
          var diamondCostE = ( numberOfStones * settingCharge ) + ( totaldiamondweight * diamondPercarate );
          var widthPerMM = ( nineCto28 / widthrNeverChange * widthrequired ) / 17.2;
          var hallmarkPerGramCostCost = ( hallmarkPerGramCostCost2 * exchangerate );
           console.log("hallmarkPerGramCostCost",hallmarkPerGramCostCost);
          if(getvalue == 'ct14'){
            var gold$Cost = ( gold$B + 50 ) * 1.06 / 31.1 * 0.575;
          }else if(getvalue == 'ct18') {
            var gold$Cost = ( gold$B + 50 ) * 1.06 / 31.1 * 0.75;
          }else if(getvalue == 'ct22') {
            var gold$Cost = ( gold$B + 50 ) * 1.06 / 31.1 * 0.916;
          }
          var hay = ( labour9ct / exchangerate ) * markupnormal + hallmarkPerGramCostCost2;
           console.log("hay",hay);
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * markupnormal + boxAndPouchCost;
          var columnBeforeTotalPriceColumn = ( columnAfterSizeColumn * widthPerMM );
          var columnBeforeTotalPriceColumn = ( columnBeforeTotalPriceColumn * ct9_14ct );
          //alert(columnBeforeTotalPriceColumn);
          var SellPerGram = (gold$Cost) / exchangerate * markupnormal;
           console.log("SellPerGram",SellPerGram);
          var totalPrice = ( SellPerGram * columnBeforeTotalPriceColumn ) + diamondSellEWithBox + hay;
            console.log("totalPrice",totalPrice);
          var baseprice = parseFloat($('.customOptions').attr('data-baseprice'));
          if(!isNaN(baseprice)) {
            var baseprice = baseprice;
          }else{
            var baseprice = 0;
          }
          var totalPrice = totalPrice + baseprice;
          
            $('#product_price').text('£'+totalPrice.toFixed(2));
            totle_price = '£'+totalPrice.toFixed(2);
        }

        //platinum, Platinum_18ct function js
        function PlatinumITG(getvalue) {
          var number_of_diamonds = $('.optionNumberDiamonds input').val();
          if(number_of_diamonds != ''){
            var number_of_diamonds = parseFloat(number_of_diamonds);
          }else{
            var number_of_diamonds = 1;
          }
          
          var weight_per_diamonds_input = $('.optionIndividualDiamondWeight input').val();
          if(weight_per_diamonds_input != ''){
            var weight_per_diamonds = parseFloat(weight_per_diamonds_input);
          }else{
            var weight_per_diamonds = 1;
          }
    
          var width_select = $(".optionWidth input[type='radio']:checked").val();
          //alert(width_select);
          //size_column
          var size_options = $(".optionSizes input[type='radio']:checked").val();
          var size_options = 'size_column_'+size_options;
          if(size_options in data_pro){
              var size_option = data_pro[size_options];
          }

          //labour all size
          var labour_size_option = $(".optionCarat input[type='radio']:checked").val();
          var labour_size_option = 'labour_'+labour_size_option;
          if(labour_size_option in data_pro){
            var optionCarat = data_pro[labour_size_option];
          }

          //formula start
          var markupnormal = parseFloat(data_pro.mark_up_normal);
          var exchangerate = parseFloat(data_pro.exchange_rate);
          var labour9ct = parseFloat(optionCarat);
          
          var diamondPercarate = parseFloat(data_pro.diamonds_per_carat);
          var settingCharge = parseFloat(data_pro.setting_charge);
          var numberOfStones = number_of_diamonds;
          var boxAndPouchCost = parseFloat(data_pro.box_pouch_cost);
          var widthrequired = parseFloat(width_select);
          var widthrNeverChange = parseFloat(data_pro.width_never_change);
          var markupnormal_Platinum = parseFloat(data_pro.mark_up_platinum);
          var ct9_14ct = parseFloat(data_pro.ct9_to_platinum_B);
          
          var nineCto28 = parseFloat(data_pro.nine_ct_to_i28);
          var columnAfterSizeColumn = parseFloat(size_option);
          var hallmarkPerGramCostCost2 = parseFloat(data_pro.hallmark_per_gram_cost);
          var gold$B = parseFloat(data_pro.platinum_b);
  
          var totaldiamondweight = parseFloat(number_of_diamonds) * parseFloat(weight_per_diamonds);
          var diamondCostE = ( numberOfStones * settingCharge ) + ( totaldiamondweight * diamondPercarate );
          var widthPerMM = ( nineCto28 / widthrNeverChange * widthrequired ) / 17.2;
          var hallmarkPerGramCostCost = ( hallmarkPerGramCostCost2 * exchangerate );
          
          var gold$Cost = ( gold$B + 50 ) * 1.15 / 31.1;

          var hay = ( labour9ct / exchangerate ) * markupnormal_Platinum;
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * markupnormal + boxAndPouchCost;
          var columnBeforeTotalPriceColumn = ( columnAfterSizeColumn * widthPerMM );
          var columnBeforeTotalPriceColumn = ( columnBeforeTotalPriceColumn * ct9_14ct );
          //alert(columnBeforeTotalPriceColumn);
          var SellPerGram = ( gold$Cost + hallmarkPerGramCostCost ) / exchangerate * markupnormal_Platinum;
          var totalPrice = ( SellPerGram * columnBeforeTotalPriceColumn ) + diamondSellEWithBox + hay;
            
          var baseprice = parseFloat($('.customOptions').attr('data-baseprice'));
          if(!isNaN(baseprice)) {
            var baseprice = baseprice;
          }else{
            var baseprice = 0;
          }
          var totalPrice = totalPrice + baseprice;
          
            $('#product_price').text('£'+totalPrice.toFixed(2));
            totle_price = '£'+totalPrice.toFixed(2);
        }

        //Palladium, Palladium_9ct function js
        function PalladiumITG(getvalue) {
          var number_of_diamonds = $('.optionNumberDiamonds input').val();
          if(number_of_diamonds != ''){
            var number_of_diamonds = parseFloat(number_of_diamonds);
          }else{
            var number_of_diamonds = 1;
          }
          
          var weight_per_diamonds_input = $('.optionIndividualDiamondWeight input').val();
          if(weight_per_diamonds_input != ''){
            var weight_per_diamonds = parseFloat(weight_per_diamonds_input);
          }else{
            var weight_per_diamonds = 1;
          }
    
          var width_select = $(".optionWidth input[type='radio']:checked").val();
          //alert(width_select);
          //size_column
          var size_options = $(".optionSizes input[type='radio']:checked").val();
          var size_options = 'size_column_'+size_options;
          if(size_options in data_pro){
              var size_option = data_pro[size_options];
          }

          //labour all size
          var labour_size_option = $(".optionCarat input[type='radio']:checked").val();
          var labour_size_option = 'labour_'+labour_size_option;
          if(labour_size_option in data_pro){
            var optionCarat = data_pro[labour_size_option];
          }

          //formula start
          var markupnormal = parseFloat(data_pro.mark_up_normal);
          var exchangerate = parseFloat(data_pro.exchange_rate);
          var labour9ct = parseFloat(optionCarat);
          
          var diamondPercarate = parseFloat(data_pro.diamonds_per_carat);
          var settingCharge = parseFloat(data_pro.setting_charge);
          var numberOfStones = number_of_diamonds;
          var boxAndPouchCost = parseFloat(data_pro.box_pouch_cost);
          var widthrequired = parseFloat(width_select);
          var widthrNeverChange = parseFloat(data_pro.width_never_change);
          var markupnormal_Platinum = parseFloat(data_pro.mark_up_palladium);
          var ct9_14ct = parseFloat(data_pro.ct9_to_palladium_B);
          
          var nineCto28 = parseFloat(data_pro.nine_ct_to_i28);
          var columnAfterSizeColumn = parseFloat(size_option);
          var hallmarkPerGramCostCost2 = parseFloat(data_pro.hallmark_per_gram_cost);
          var gold$B = parseFloat(data_pro.palladium_b);
  
          var totaldiamondweight = parseFloat(number_of_diamonds) * parseFloat(weight_per_diamonds);
          var diamondCostE = ( numberOfStones * settingCharge ) + ( totaldiamondweight * diamondPercarate );
          var widthPerMM = ( nineCto28 / widthrNeverChange * widthrequired ) / 17.2;
          var hallmarkPerGramCostCost = ( hallmarkPerGramCostCost2 * exchangerate );
          
          var gold$Cost = ( gold$B + 50 ) * 1.15 / 31.1;

          var hay = ( labour9ct / exchangerate ) * markupnormal_Platinum;
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * markupnormal + boxAndPouchCost;
          var columnBeforeTotalPriceColumn = ( columnAfterSizeColumn * widthPerMM );
          var columnBeforeTotalPriceColumn = ( columnBeforeTotalPriceColumn * ct9_14ct );
          //alert(columnBeforeTotalPriceColumn);
          if(getvalue == 'Palladium'){
            var SellPerGram = ( gold$Cost + hallmarkPerGramCostCost ) / exchangerate * markupnormal_Platinum;
          }else{
            var SellPerGram = ( gold$Cost + hallmarkPerGramCostCost ) / exchangerate * markupnormal;
          }
          var totalPrice = ( SellPerGram * columnBeforeTotalPriceColumn ) + diamondSellEWithBox + hay;

          var baseprice = parseFloat($('.customOptions').attr('data-baseprice'));
          if(!isNaN(baseprice)) {
            var baseprice = baseprice;
          }else{
            var baseprice = 0;
          }
          var totalPrice = totalPrice + baseprice;
            
            $('#product_price').text('£'+totalPrice.toFixed(2));
            totle_price = '£'+totalPrice.toFixed(2);
        }

        //Silver function js
        function SilverITG(getvalue) {
          var number_of_diamonds = $('.optionNumberDiamonds input').val();
          if(number_of_diamonds != ''){
            var number_of_diamonds = parseFloat(number_of_diamonds);
          }else{
            var number_of_diamonds = 1;
          }
          
          var weight_per_diamonds_input = $('.optionIndividualDiamondWeight input').val();
          if(weight_per_diamonds_input != ''){
            var weight_per_diamonds = parseFloat(weight_per_diamonds_input);
          }else{
            var weight_per_diamonds = 1;
          }
    
          var width_select = $(".optionWidth input[type='radio']:checked").val();
          //alert(width_select);
          //size_column
          var size_options = $(".optionSizes input[type='radio']:checked").val();
          var size_options = 'size_column_'+size_options;
          if(size_options in data_pro){
              var size_option = data_pro[size_options];
          }

          //labour all size
          var labour_size_option = $(".optionCarat input[type='radio']:checked").val();
          var labour_size_option = 'labour_'+labour_size_option;
          if(labour_size_option in data_pro){
            var optionCarat = data_pro[labour_size_option];
          }

          //formula start
          var markupnormal = parseFloat(data_pro.mark_up_normal);
          var exchangerate = parseFloat(data_pro.exchange_rate);
          var labour9ct = parseFloat(optionCarat);
          
          var diamondPercarate = parseFloat(data_pro.diamonds_per_carat);
          var settingCharge = parseFloat(data_pro.setting_charge);
          var numberOfStones = number_of_diamonds;
          var boxAndPouchCost = parseFloat(data_pro.box_pouch_cost);
          var widthrequired = parseFloat(width_select);
          var widthrNeverChange = parseFloat(data_pro.width_never_change);
          var mark_up_silver = parseFloat(data_pro.mark_up_silver);
          
          if(getvalue == 'Silver'){
          var ct9_14ct = parseFloat(data_pro.ct9_to_silver_B);
          }else if(getvalue == 'Titanium') {
          var ct9_14ct = parseFloat(data_pro.ct9_to_titanium_B);
          }
          var cz_d = parseFloat(data_pro.cz_D);
          var hallmarkPerPieceSell_d = parseFloat(data_pro.hallmark_per_piece_sell_D);
          
          var nineCto28 = parseFloat(data_pro.nine_ct_to_i28);
          var columnAfterSizeColumn = parseFloat(size_option);
          var hallmarkPerGramCostCost2 = parseFloat(data_pro.hallmark_per_gram_cost);
          var gold$B = parseFloat(data_pro.silver_b);
  
          var totaldiamondweight = parseFloat(number_of_diamonds) * parseFloat(weight_per_diamonds);
          var diamondCostE = cz_d * numberOfStones ;
          var widthPerMM = ( nineCto28 / widthrNeverChange * widthrequired ) / 17.2;
          var hallmarkPerGramCostCost = ( hallmarkPerGramCostCost2 * exchangerate );

          if(getvalue == 'Silver'){
            var gold$Cost = ( gold$B + 5 ) / 31.1;
          }else if(getvalue == 'Titanium') {
            var gold$Cost = 0;
          }          

          var hay = ( labour9ct / exchangerate ) * mark_up_silver;
            
          if(getvalue == 'Silver'){
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * mark_up_silver + boxAndPouchCost + hallmarkPerPieceSell_d;
          }else if(getvalue == 'Titanium') {
          var diamondSellEWithBox = ( diamondCostE / exchangerate ) * mark_up_silver + boxAndPouchCost;
          }

          var columnBeforeTotalPriceColumn = ( columnAfterSizeColumn * widthPerMM );
          var columnBeforeTotalPriceColumn = ( columnBeforeTotalPriceColumn * ct9_14ct );
          if(getvalue == 'Silver'){
          var SellPerGram = gold$Cost / exchangerate  * mark_up_silver;
          }else if(getvalue == 'Titanium') {
          var SellPerGram = (gold$Cost + hallmarkPerPieceSell_d) / exchangerate  * mark_up_silver;
          }
          //console.log(SellPerGram);

          var totalPrice = ( SellPerGram * columnBeforeTotalPriceColumn ) + diamondSellEWithBox + hay;

          
          //console.log(totalPrice);
          var baseprice = parseFloat($('.customOptions').attr('data-baseprice'));
          if(!isNaN(baseprice)) {
            var baseprice = baseprice;
          }else{
            var baseprice = 0;
          }
          var totalPrice = totalPrice + baseprice;
          //console.log(totalPrice + 'dddd'+ baseprice);
          $('#product_price').text('£'+totalPrice.toFixed(2));
          totle_price = '£'+totalPrice.toFixed(2);
        }
        
      }

    //Carat change option
    $('.optionCarat input[type="radio"]').change(function() {
      var value_select = $.trim($(this).val());
      if(value_select== '9ct'){
        ct9ITG();
      }else if(value_select == '14ct') {
        Ct14ITG('ct14');
      }else if(value_select == '18ct') {
        Ct14ITG('ct18');
      }else if(value_select == '22ct') {
        Ct14ITG('ct22');
      }else if(value_select == 'Platinum') {
        PlatinumITG('platinum');
      }else if(value_select == 'Platinum_18ct') {
        PlatinumITG('Platinum_18ct');
      }else if(value_select == 'Palladium') {
        PalladiumITG('Palladium');
      }else if(value_select == 'Palladium_9ct') {
        PalladiumITG('Palladium_9ct');
      }else if(value_select == 'Silver') {
        SilverITG('Silver');
      }else if(value_select == 'Titanium') {
        SilverITG('Titanium');
      }
    });

    //Sizes change option
    $('.optionSizes input[type="radio"]').change(function() {
      var value_select = $.trim($(".optionCarat input:checked").val());
      if(value_select== '9ct'){
        ct9ITG();
      }else if(value_select == '14ct') {
        Ct14ITG('ct14');
      }else if(value_select == '18ct') {
        Ct14ITG('ct18');
      }else if(value_select == '22ct') {
        Ct14ITG('ct22');
      }else if(value_select == 'Platinum') {
        PlatinumITG('platinum');
      }else if(value_select == 'Platinum_18ct') {
        PlatinumITG('Platinum_18ct');
      }else if(value_select == 'Palladium') {
        PalladiumITG('Palladium');
      }else if(value_select == 'Palladium_9ct') {
        PalladiumITG('Palladium_9ct');
      }else if(value_select == 'Silver') {
        SilverITG('Silver');
      }else if(value_select == 'Titanium') {
        SilverITG('Titanium');
      }
    });
    
    //optionWidth change option
    $('.optionWidth input[type="radio"]').change(function() {
      var value_select = $.trim($(".optionCarat input:checked").val());
      if(value_select== '9ct'){
        ct9ITG();
      }else if(value_select == '14ct') {
        Ct14ITG('ct14');
      }else if(value_select == '18ct') {
        Ct14ITG('ct18');
      }else if(value_select == '22ct') {
        Ct14ITG('ct22');
      }else if(value_select == 'Platinum') {
        PlatinumITG('platinum');
      }else if(value_select == 'Platinum_18ct') {
        PlatinumITG('Platinum_18ct');
      }else if(value_select == 'Palladium') {
        PalladiumITG('Palladium');
      }else if(value_select == 'Palladium_9ct') {
        PalladiumITG('Palladium_9ct');
      }else if(value_select == 'Silver') {
        SilverITG('Silver');
      }else if(value_select == 'Titanium') {
        SilverITG('Titanium');
      }
      
    }); 

    $(document).on("change blur input", ".change_input", function(){
      var value_select = $.trim($(".optionCarat input:checked").val());
      if(value_select== '9ct'){
        ct9ITG();
      }else if(value_select == '14ct') {
        Ct14ITG('ct14');
      }else if(value_select == '18ct') {
        Ct14ITG('ct18');
      }else if(value_select == '22ct') {
        Ct14ITG('ct22');
      }else if(value_select == 'Platinum') {
        PlatinumITG('platinum');
      }else if(value_select == 'Platinum_18ct') {
        PlatinumITG('Platinum_18ct');
      }else if(value_select == 'Palladium') {
        PalladiumITG('Palladium');
      }else if(value_select == 'Palladium_9ct') {
        PalladiumITG('Palladium_9ct');
      }else if(value_select == 'Silver') {
        SilverITG('Silver');
      }else if(value_select == 'Titanium') {
        SilverITG('Titanium');
      }
    });


    //page load js

      var value_select = $.trim($(".optionCarat input:checked").val());
      if(value_select== '9ct'){
        ct9ITG();
      }else if(value_select == '14ct') {
        Ct14ITG('ct14');
      }else if(value_select == '18ct') {
        Ct14ITG('ct18');
      }else if(value_select == '22ct') {
        Ct14ITG('ct22');
      }else if(value_select == 'Platinum') {
        PlatinumITG('platinum');
      }else if(value_select == 'Platinum_18ct') {
        PlatinumITG('Platinum_18ct');
      }else if(value_select == 'Palladium') {
        PalladiumITG('Palladium');
      }else if(value_select == 'Palladium_9ct') {
        PalladiumITG('Palladium_9ct');
      }else if(value_select == 'Silver') {
        SilverITG('Silver');
      }else if(value_select == 'Titanium') {
        SilverITG('Titanium');
      }


    //add to cart 
    $('.itg_cart ').click(function(){
    $('.input_requied').each(function(){
      var this_val = $(this).val();
      if(this_val != ''){
        $(this).removeClass('error_itg');
      }else{
        $(this).addClass('error_itg').focus();
      }
    });

    var numItems = $('.error_itg').length
      
      if(totle_price != '' && numItems == 0){
        $(".pre_loader").css("display", "flex").show();

        $.ajax({
          type: "POST",
          url: "https://dev.shopifyexperthelp.com/app/AMLWeddingBands/product_add_to_cart.php",
          data:{
            'product_id': product_id,
            'price': totle_price
          },
          async: false,
          success: function(id) {
          var id = id;
           if(id != ''){
             $('.itg_id').val(id);
              setTimeout(function() {
                $.ajax({
                    type: 'POST', 
                    url: '/cart/add.js',
                    dataType: 'json', 
                    data: $('.product-form').serialize(),
                    success: function(){
                     window.location.href = "/checkout?discount=47SYT2S2MFX3";
                    }
                  }); 
                 //$('.hide_btns').click();
              }, 2000);   
          }
        }
        });
      }
    });

    //pay order draft
        function customButtonPayClick() {
          var OrderColourVal = '';
          var OrderFinishVal = '';
          var EngravingFieldVal = '';
          var NotesVal = '';
          var CaratVal= $(document).find('.optionCarat input[name="properties[carat]"]:checked').val();
          var SizeVal=  $(document).find('.optionSizes input[name="properties[sizes]"]:checked').val();
          var HalfSizeVal= $(document).find('.optionHalfSize input[name="properties[half_size]"]:checked').val();  
          var WidthVal=   $(document).find('.optionWidth input[name="properties[width]"]:checked').val();
          var ColourVal= $(document).find('.optionColour input[name="properties[colour]"]:checked').val();
          var OrderColourVal= $(document).find('.optionOrderColour input[name="properties[order_of_colour]"]').val();  
          var FinishVal= $(document).find('.optionFinish input[name="properties[finish]"]:checked').val();
          var OrderFinishVal= $(document).find('.optionOrderFinish input[name="properties[order_of_finish]"]').val();
          var EngravingVal= $(document).find('.optionEngraving input[name="properties[engraving]"]:checked').val();  
          var EngravingFieldVal = $(document).find('.optionEngravingField input[name="properties[engraving_field]"]').val();
          var NotesVal   = $(document).find('.optionNotes input[name="properties[notes]"]').val();
          var product_title = $(document).find('.product__title').text();         
          var customBtnPay = $(this);
          var Notes = ''

      Notes += "Carat:"+ CaratVal+",";
      Notes += "Sizes:"+ SizeVal+",";
      Notes += "Click Half size:"+ HalfSizeVal+",";
      Notes += "Width:"+ WidthVal+",";
      Notes += "Colour:"+ ColourVal+",";
      if(OrderColourVal != ''){
        Notes += "Order Of Colour:"+ OrderColourVal+",";
      }
        Notes += "Finish:"+ FinishVal+",";
      if(OrderFinishVal != ''){
        Notes += "Order Of Finish:"+ OrderFinishVal+",";
      }
        Notes += "Engraving (inside wedding band):"+ EngravingVal+",";
      if(EngravingFieldVal != ''){
        Notes += "Engraving Wording:"+ EngravingFieldVal+",";
        }
       if(NotesVal != ''){
        Notes += "Any Notes / Extra information:"+ NotesVal+",";
       }
          customBtnPay.find('.btn__text').text('Loading..');
          $(".pre_loader").addClass('show_loader');
          var customer_id = $('.customOptions').attr('data-customer-id');
          var product_qty = $('.select-popout .select-popout__toggle span').text();
          if (customer_id !== '') {
            $.ajax({
                type: "POST",
                url: "https://dev.shopifyexperthelp.com/app/AMLWeddingBands/draft_order/draft_order.php",
                data: {
                     'all_note':Notes,
                    'customer_id': customer_id,
                    'product_qty': product_qty,
                    'product_id': product_id,
                    'product_title':product_title,
                    'price': totle_price,
                    'CaratVal':CaratVal,               
                    'SizeVal':SizeVal,          
                    'HalfSizeVal':HalfSizeVal,  
                    'WidthVal':WidthVal,        
                    'ColourVal':ColourVal,        
                    'OrderColourVal':OrderColourVal,   
                    'FinishVal':FinishVal,        
                    'OrderFinishVal':OrderFinishVal,   
                    'EngravingVal':EngravingVal,     
                    'EngravingFieldVal':EngravingFieldVal,
                    'NotesVal':NotesVal        
                },
                beforeSend: function (orderId) {
                    customBtnPay.find('.btn__text').text('Loading..');
                },
                success: function (orderId) {
                    if (orderId !== '') {
                        setTimeout(function () {
                            $(".pre_loader").hide().removeClass('show_loader');
                            $('.product_popup').show();
                            customBtnPay.find('.btn__text').text('Place an order and not pay');
                        }, 2500);
                    }
                },
                error: function () {
                    customBtnPay.find('.btn__text').text('Place an order and not pay');
                }
            });
          } else {
            $(".pre_loader").css("display", "flex").hide();
          }
        }

$(document).on("click", ".custom_btn_pay", customButtonPayClick);

   $('.close_img_popup').click(function(){
      $('.product_popup').hide();
   });
    
  }  

}
  
});
  